/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    arrayOf, string, shape, bool,
} from 'prop-types';
import { useSelector } from 'react-redux';

import { useUID } from 'react-uid';
import { getFeatureFlag } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import ProductRecommendationsSFContainer from './ProductRecommendationsSFContainer';
import useVisibility from '../../../helpers/hooks/useVisibility';

const ProductRecommendationsContainer = ({
    partNumber,
    skuData,
    recommendationData,
    productName,
    isPdpRedesignEnabled,
    isPdpRedesignShortEnabled,
    isPlaRedesignEnabled,
}) => {
    const isSalesForceRecsEnabled = useSelector(getFeatureFlag('is-salesforce-recs-enabled'));
    const isSympathySku = skuData.some((sku) => sku.sympathyValue === '1' || sku.sympathyValue === '2');

    const callbackId = useUID(); // used to generate unique callback id
    const [visible, ref] = useVisibility(callbackId, { rootMargin: '0%' });

    if (isSalesForceRecsEnabled) {
        return (
            <div data-staticid={callbackId} ref={ref} className="pdp-recs">
                {visible && (
                    <ProductRecommendationsSFContainer
                        recommendationData={recommendationData}
                        isSympathySku={isSympathySku}
                        partNumber={partNumber}
                        productName={productName}
                        isPdpRedesignEnabled={isPdpRedesignEnabled}
                        isPdpRedesignShortEnabled={isPdpRedesignShortEnabled}
                        isPlaRedesignEnabled={isPlaRedesignEnabled}
                    />
                )}
            </div>
        );
    }

    return null;
};

ProductRecommendationsContainer.propTypes = {
    partNumber: string.isRequired,
    productName: string.isRequired,
    skuData: arrayOf(shape({
        sympathyValue: string,
    })).isRequired,
    recommendationData: shape({
        title_font_color: shape({
            color: string.isRequired,
        }),
        title_font_size: string,
        title_font_style: string,
        title_font_family: string,
        title_font_weight: string,
    }).isRequired,
    isPdpRedesignEnabled: bool,
    isPdpRedesignShortEnabled: bool,
    isPlaRedesignEnabled: bool,
};
ProductRecommendationsContainer.defaultProps = {
    isPdpRedesignEnabled: false,
    isPdpRedesignShortEnabled: false,
    isPlaRedesignEnabled: false,
};

export default ProductRecommendationsContainer;
